// src/components/ProfileDropdown.ts
import "./ProfileDropdown.css";
import { useAuth } from "../context/useAuth";

function getProfileColor(email: string): string {
  const colors = ["#4285f4", "#ea4335", "#fbbc05", "#34a853", "#a142f4"];
  let hash = 0;

  for (let i = 0; i < email.length; i += 1) {
    hash = email.charCodeAt(i) + ((hash << 5) - hash);
  }

  return colors[Math.abs(hash) % colors.length];
}

export function renderProfileDropdown(
  anchor: HTMLElement,
  onClose: () => void,
) {
  const existing = document.querySelector(".profile-dropdown");
  if (existing) existing.remove();

  const { user } = useAuth();
  const email = user?.email ?? "";
  const shortName = email.split("@")[0] || "User";
  const profileLetter = email[0]?.toUpperCase() ?? "";
  const profileColor = email ? getProfileColor(email) : "#4285f4";

  const dropdown = document.createElement("div");
  dropdown.className = "profile-dropdown";

  dropdown.innerHTML = `
    <div class="pd-top-row">
      <span class="pd-email">${email}</span>
      <button class="pd-close-btn" type="button" aria-label="Close">✕</button>
    </div>

    <div class="pd-profile-section">
      <div class="pd-profile-icon" style="background-color: ${profileColor}">
        ${profileLetter}
        <div class="pd-plus">+</div>
      </div>

      <p class="pd-welcome">Welcome, ${shortName}!</p>

      <button class="pd-manage-btn" type="button">
        Manage your AMailMe Account
      </button>
    </div>

    <details class="pd-more-accounts">
      <summary>Show more accounts</summary>
      <div class="pd-more-content">
        <p class="pd-placeholder">No additional accounts</p>
      </div>
    </details>

    <div class="pd-history-section">
      <a class="pd-history-item" href="/history" style="color:inherit;text-decoration:none">🔍 AyeSearch History</a>
      <div class="pd-divider"></div>
      <button class="pd-delete-btn" type="button">
        Delete last 30 minutes
      </button>
    </div>

    <button
      class="pd-browser-download-btn"
      type="button"
    >
      Download AyeSearch Browser
    </button>

    <button class="pd-logout-btn" type="button">
      Log out
    </button>
  `;

  const stopAll = (event: Event) => event.stopPropagation();

  dropdown.addEventListener("mousedown", stopAll);
  dropdown.addEventListener("click", stopAll);
  dropdown.addEventListener("touchstart", stopAll);

  dropdown
    .querySelector(".pd-close-btn")
    ?.addEventListener("click", (event) => {
      event.stopPropagation();
      dropdown.remove();
      onClose();
    });

  dropdown
    .querySelector(".pd-browser-download-btn")
    ?.addEventListener("click", (event) => {
      event.stopPropagation();
      window.location.href = "https://ayesearch.com/downloads/update";
    });

  dropdown
    .querySelector(".pd-logout-btn")
    ?.addEventListener("click", (event) => {
      event.stopPropagation();

      window.location.replace(
        "https://api.ayesearch.com/custom_auth/web/logout/ayesearch/",
      );
    });

  dropdown.querySelector(".pd-delete-btn")?.addEventListener("click", async (event) => {
    event.stopPropagation();
    const button = event.currentTarget as HTMLButtonElement;
    if (!confirm("Delete the last 30 minutes of your AyeSearch account history?")) return;
    try {
      await fetch("/api/auth/csrf/", { credentials: "include" });
      const csrf = document.cookie.split("; ").find(x => x.startsWith("csrftoken="))?.slice(10) || "";
      const response = await fetch("/api/history/api/", { method: "DELETE", credentials: "include",
        headers: { "Content-Type": "application/json", "X-CSRFToken": decodeURIComponent(csrf) },
        body: JSON.stringify({ minutes: 30 }) });
      button.textContent = response.ok ? "Recent history deleted" : "Sign in or try again";
    } catch { button.textContent = "History temporarily unavailable"; }
  });
  anchor.appendChild(dropdown);
}
